import React from 'react';
import Table from 'react-bootstrap/Table';
import PropTypes from 'prop-types';
import { consultantDisplayName, niceDateFormatter, userNameFormatter } from '../../lib/helper/formatting';
import * as ROUTES from '../../lib/routing/frontend';
import { Link } from 'react-router-dom';
import CONSULTANT_TICKET_TYPE_CODES from '../../lib/helper/consultantTicketTypeCodes';
import { isClient } from '../../lib/helper/authorisation';

class ConsultantTicketListTable extends React.Component {
  render() {
    const { consultantTickets = [], sortField, sortDir, onSortChange } = this.props;
    const showConsultant = !isClient();

    const sortIcon = (field) => {
      if (sortField !== field) return <i className="fas fa-sort ml-1 text-muted" />;
      return sortDir === 'asc'
        ? <i className="fas fa-sort-up ml-1" />
        : <i className="fas fa-sort-down ml-1" />;
    };

    return (
      <div>
        <Table striped hover responsive className="consultant-ticket-list-table">
          <thead>
            <tr>
              <th>Ticket Type</th>
              <th>Ticket Number</th>
              <th style={{ cursor: 'pointer', whiteSpace: 'nowrap' }} onClick={() => onSortChange && onSortChange('createdAt')}>
                Created {sortIcon('createdAt')}
              </th>
              {showConsultant && <th>Consultant</th>}
              <th>Ticket Actioned</th>
              <th style={{ cursor: 'pointer', whiteSpace: 'nowrap' }} onClick={() => onSortChange && onSortChange('actionDate')}>
                Action Date {sortIcon('actionDate')}
              </th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {consultantTickets.map((ticket) => {
              const ticketUrl = ROUTES.CONSULTANT_TICKETS.SINGLE.replace(':id', ticket.id);
              const ticketTypeLabel = ticket.consultantTicketType.code === CONSULTANT_TICKET_TYPE_CODES.OTHER && ticket.typeOtherDetail
                ? `Other: ${ticket.typeOtherDetail}`
                : ticket.consultantTicketType.displayName;
              return (
                <tr key={ticket.id}>
                  <td>
                    <Link to={ticketUrl} className="text-body">
                      {ticketTypeLabel}
                    </Link>
                  </td>
                  <td>
                    <Link to={ticketUrl} className="text-body">
                      {ticket.id}
                    </Link>
                  </td>
                  <td className="text-nowrap">{niceDateFormatter(ticket.createdAt, 'DD/MM/YYYY HH:mm')}</td>
                  {showConsultant && (
                    <td>
                      {ticket.consultantTicketType.code === CONSULTANT_TICKET_TYPE_CODES.CONSULTANT_BROADCAST
                        ? 'All ' + (ticket.consultantType?.displayName ?? 'Consultant') + 's' + (ticket.includeSecretaries ? ' and Secretaries' : '')
                        : consultantDisplayName(ticket.consultant)}
                    </td>
                  )}
                  <td>
                    {ticket.actionedDate ? (
                      <i
                        className="mr-1 fa fa-check-circle text-primary"
                        title={`Actioned ${niceDateFormatter(ticket.actionedDate, 'DD/MM/YYYY HH:mm')}${ticket.actionedBy ? ' by ' + userNameFormatter(ticket.actionedBy) : ''}`}
                      />
                    ) : (
                      <i className="mr-1 fa fa-times-circle text-danger" title="Not Actioned" />
                    )}
                  </td>
                  <td>{ticket.actionDate ? niceDateFormatter(ticket.actionDate, 'DD/MM/YYYY') : ''}</td>
                  <td>
                    <Link to={ticketUrl} className="btn btn-sm btn-primary ml-2">
                      View
                    </Link>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  }
}

ConsultantTicketListTable.propTypes = {
  consultantTickets: PropTypes.array.isRequired,
  sortField: PropTypes.string,
  sortDir: PropTypes.string,
  onSortChange: PropTypes.func,
};

export default ConsultantTicketListTable;
